<!--  -->
<template>
  <div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width:100%; height: 100%;"
        border
        max-height="500"
      >
        <el-table-column
          align="center"
          label="小程序名称"
          prop="name"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.name }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="小程序名称"
              trigger="hover"
              :content="scope.row.name"
            >
              <p slot="reference" class="titip">{{ scope.row.name }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.textName" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="小程序appid"
          prop="app_id"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.corp_id }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="小程序appid"
              width="200"
              trigger="hover"
              :content="scope.row.app_id"
            >
              <p slot="reference" class="titip">{{ scope.row.app_id }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.textAppId" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="ghId"
          prop="gh_id"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.secret }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="ghId"
              width="200"
              trigger="hover"
              :content="scope.row.gh_id"
            >
              <p slot="reference" class="titip">{{ scope.row.gh_id }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.textGhId" />
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="路径"
          prop="pagepath"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.secret }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="路径"
              width="200"
              trigger="hover"
              :content="scope.row.pagepath"
            >
              <p slot="reference" class="titip">{{ scope.row.pagepath }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.textPagepath" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="备注"
          prop="remark"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.secret }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="备注"
              width="200"
              trigger="hover"
              :content="scope.row.remark"
            >
              <p slot="reference" class="titip">{{ scope.row.remark }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.remark" />
          </template>
        </el-table-column>
        <el-table-column
          :key="mathRandom"
          label="操作"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="success"
              size="mini"
              @click="chooser(scope.row)"
            >
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import { kfmpstorelist } from '@/api/providerAccountManagement/servicePorviderList1.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      mathRandom: null,
      tableData: [],
      loading: false,
      total: null,
      query: {
        page: 1,
        page_size: 10
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send() {
      console.log('111')
      this.accountlist()
    },
    chooser(item) {
      console.log(item)
      this.$emit('callbackwechat', item)
    },
    async accountlist() {
      this.loading = true
      const data = await kfmpstorelist(this.query)
      for (let i = 0; i < data.data.list.length; i++) {
        data.data.list[i].textAppId = data.data.list[i].app_id
        data.data.list[i].textName = data.data.list[i].name
        data.data.list[i].textGhId = data.data.list[i].gh_id
        data.data.list[i].textPagepath = data.data.list[i].pagepath

        data.data.list[i].isModify = false
      }
      this.loading = false
      this.tableData = data.data.list
      this.total = data.data.total
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.accountlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.accountlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.titip{
    width: 170px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* 这里是超出几行省略 */
    overflow: hidden;
    margin: 0 auto;
    text-align: center;
}
</style>
